import { createFileRoute } from '@tanstack/react-router';
import { dispenserQueries } from '@/features/dispensers/queries.ts';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton.tsx';
import { goToNotFoundIf404 } from '@/common/utils/goToNotFoundIf404.ts';

export const Route = createFileRoute('/dispensers/$dispenserId')({
  loader: async ({ context, params }) => {
    return goToNotFoundIf404(async () => {
      const dispenser = await context.queryClient.ensureQueryData(
        dispenserQueries.detail(params.dispenserId)
      );

      return {
        breadcrumb: dispenser.sn,
      };
    });
  },
  pendingComponent: DetailsPageSkeleton,
});
